<template>
    <confirmation-dialog
        ref="dialog"
        label="Je AI Agent krijgt een persoonlijk tintje!"
        description="Je AI Agent krijgt een persoonlijk tintje!"
    >
        <template #default>
            <flex-container>
                <flex-container justify-content="center">
                    <component
                        :is="GeneratingIllustration"
                        :style="{
                            color: getCssColor('default', 'primary'),
                            width: '50%',
                        }"
                    />
                </flex-container>
                <text-heading>Je AI Agent krijgt een persoonlijk tintje!</text-heading>
                <text-description>
                    Op dit moment kun je jouw AI Agent nog niet bewerken, maar dat is met een goede reden!<br>
                    <br>
                    Achter de schermen zijn slimme AI’s druk bezig met onderzoek naar jouw bedrijf of organisatie. Ze nemen al jouw voorkeuren mee en creëren een AI-persoonlijkheid die perfect bij jou past.
                    Geen zorgen, je hoeft niets te doen! Zodra alles klaar is, ontvang je een mailtje. Dit duurt meestal niet langer dan 15 minuten.<br>
                    <br>
                    Even geduld – jouw AI Agent wordt helemaal op maat gemaakt!
                </text-description>
            </flex-container>
        </template>
        <template #actions="{ bindings }">
            <button-block
                @loading="(event) => {
                    event.button.setState(ButtonState.content);
                    bindings.overlay.closeOverlay();
                }"
            >
                Sluiten
            </button-block>
        </template>
    </confirmation-dialog>
</template>

<script setup lang="ts">
    import { ButtonState, ConfirmationDialog, type ExposedOverlay, getCssColor } from '@keyvue/one-ui';
    import GeneratingIllustration from '@/ai/assistent/assets/illustrations/generating.svg?component';
    import { ref } from 'vue';

    const dialog = ref<ExposedOverlay>();

    defineExpose({
        dialog,
    });
</script>
